function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.525 19.554l-.65 1.019-3.317-2.41h2.05l1.917 1.39zM0 15.296l5.858-4.223.65 1.02L2.192 15.2H20l-.458 1.227H0v-1.132zM13.475 9.018l.65 1.02 3.317-2.41h-2.05l-1.917 1.39zM20 4.76L14.142.539l-.65 1.019 4.316 3.109H0l.458 1.226H20V4.761z",
  fill: "params(fill) #211FAB"
});

function SvgCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCompare;